import { productFamilyIdFormat } from "@redotech/redo-model/ids";
import { ChannelSchema } from "@redotech/redo-model/marketplace/channels";
import * as z from "zod";

export const publishProductFamilies = {
  name: "publishProductFamilies" as const,
  input: z.object({
    productFamilyIds: z.array(productFamilyIdFormat.schema).min(1),
    channel: ChannelSchema,
  }),

  output: z.object({
    results: z.array(
      z.object({
        productFamilyId: productFamilyIdFormat.schema,
        success: z.boolean(),
        error: z.string().optional(),
      }),
    ),
  }),
};
